import * as Keycloak from 'keycloak-js';
import {initOptions} from '@/auth/resources/KeycloakInitOptions';
import subscriberManager from '../../subscriber/managers/SubscriberManager';

// @ts-ignore
const keycloak = new Keycloak(initOptions);

export function startSession():Promise<Keycloak.KeycloakInstance> {
    const ON_LOAD_TYPE = 'login-required';

    return keycloak.init({ onLoad: ON_LOAD_TYPE}).then((auth:any) => {
        if (!auth) {
            window.location.reload();
            return keycloak
        }            

        saveTokenInStorage(keycloak.token)
        return keycloak
    });
}

export function updateToken(time:number = 60):Promise<Keycloak.KeycloakInstance> {
    return keycloak.updateToken(time).then((refreshed:any) => { 
        return keycloak;
    })
}

export function logout():Promise<Keycloak.KeycloakInstance> {
    return keycloak.logout().then(() => {
        subscriberManager.removeSubscriberFromStorage();
        return keycloak;
    })
}

function saveTokenInStorage(token:string):void {
    window.localStorage.setItem('authorization', token);
}
